import { Component, inject } from '@angular/core';

import { AuthService } from '../../auth/auth.service';

import { DialogHandlerComponent } from '../../shared/dialog-handler/dialog-handler.component';

@Component({
    selector: 'user-account-edit',
    templateUrl: './user-account-edit.component.html',
    standalone: false
})
export class UserAccountEditComponent extends DialogHandlerComponent {
  authService = inject(AuthService);
  user: Object = undefined;
  asAdmin: boolean = false;
  oldPassword: string = '';
  passwordsMatch: boolean = true;
  thisIsMe: boolean = false;

  constructor () {
    super();
    this.user = this.data['document'];
    this.asAdmin = this.data['asAdmin'] || false;
    this.thisIsMe = this.user['_id'] === this.authService.getUser()._id;
  };

  override save () {
    if ((this.user['password'] != null && this.user['password'].trim() !== "") && this.user['password'] !== this.user['password2']) {
      this.user['password'] = "";
    }
    this.dialogRef.close({
      documentName: "User",
      document: this.user
    });
  };
}
